/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Aggiorna',
    ENERGYPERFORMANCE: 'Risparmio energetico',
    UTILITYBILLSAVINGS: 'Addebiti per le bollette ',
    DateFrom: 'Data iniziale',
    SITES: 'Siti',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Punteggio gestione energia',
    BASELINE: 'Riferimento',
    BASELINEKEY: 'Consumo di riferimento',
    ACTUALKEY: 'Consumo effettivo',
    SAVINGS: 'Risparmi',
    ACTUAL: 'Effettivo',
    PARTIAL_MONTH: 'Mese parziale',
    ACTUALEMISSIONS: 'Emissioni effettive',
    ACTUALEMIS: 'Emis. effettive',
    PREVIOUSEMIS: 'Emissioni precedenti',
    PREVIOUSEMISSIONS: 'Emissioni precedenti',
    TOTALCONSUMPTION: 'Consumo totale',
    EMISSION: 'Emissioni',
    ACTUALAVOIDANCE: 'Eliminazione effettiva',
    PREVIOUSPERIOD: 'Periodo precedente',
    PREVIOUS: 'Precedente',
    PREVIOUSAVOIDANCE: 'Contenimento precedente',
    ACTUALCOST: 'Costo effettivo',
    actualCost: 'CONS. EFFETT.',
    BASELINECOST: 'Costo di riferimento',
    baselineCost: 'CONS. DI RIFER.',
    PREVSPER: 'PERIODO PRECEDENTE',
    PREVIOUSCOST: 'Costo precedente',
    VIEWDETAILS: 'VISUALIZZA DETTAGLI',
    ADVANCED: 'Avanzato',
    BASIC: 'Base',
    MONTHLY: 'Mensile',
    BILLING: 'Fatturazione',
    LIVEMETER: 'Misuratori in tempo reale',
    UTILITYMETER: 'Contatori di utenze',
    LIVEREADING: 'Misuratori sul posto',
    UTILITYINTERVAL: 'Intervallo di utenze',
    UTILITYPROVIDERNEW: 'Utenze mensili',
    ACTUALCONSUMPTION: 'Consumo effettivo',
    BASELINECONSUMPTION: 'Consumo di riferimento',
    PREDICTED: 'Previsto',
    Utilitycost: 'Costo del servizio per',
    UtilityBill: 'Profilo bolletta',
    UtilityCost: 'Costo del servizio',
    ActualCost: 'Costo effettivo',
    CostPercentage: 'Costo %',
    Electricity: 'Elettricità',
    Gas: 'Gas',
    Water: 'Acqua',
    UtilityType: 'Tipo di servizio',
    all: 'tutto',
    electricity: 'elettricità',
    gas: 'gas',
    water: 'Acqua',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Le spese di utenza per il consumo di energia sono state generate per {siteWithDataCount} di {totalSiteCount} siti.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Le emissioni per le bollette di utenza sono state generate per {siteWithDataCount} di {totalSiteCount} siti.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Le emissioni per le letture dirette sono state generate per {siteWithDataCount} di {totalSiteCount} siti.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Le spese di utenza per il consumo di energia elettrica sono state generate per{siteWithDataCount} di {totalSiteCount} siti.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Sono state generate letture in tempo reale per {siteWithDataCount} di {totalSiteCount} siti.',
    UtilityTypeforselectutility: 'Tipo di servizio*',
    ENABLEIDSCHECKBOX: 'Abilita IDS (servizio dati a intervallo)',
    ENABLED: 'Abilitato',
    DISABLED: 'Disabilitato',
    CONVERSIONINFOMSG:
      "Fornire le credenziali per abilitare la conversione di questo numero di account da 'Manuale' a tipo di integrazione 'Automatico'. Una volta che \n    le credenziali sono verificate, il tipo di integrazione verrà aggiornato automaticamente. I dati salvati manualmente resteranno e le prossime bollette \n    saranno aggiornate automaticamente successivamente.",
    CO2: 'Anidride carbonica',
    CARBON: 'Carbonio({unit})',
    CARBONNOUNIT: 'Carbonio',
    CARBONEMISSION: 'Emissioni di carbonio',
    METERDATA1: 'Dati contatore',
    DATANEEDED: 'Dati necessari',
    METERDATA: 'Dati contatore',
    METERDATASUBTITLE:
      'Analizzare e confrontare il consumo dei contatori caricando i dati cronologici e/o mancanti del periodo.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'RIDUZIONE DEL CONSUMO',
    ELECTRICITYPERFORMANCE: 'Prestazioni elettricità',
    Electicity:
      ' I dati relativi a elettricità, gas e acqua sono integrabili nel conto personale',
    FORECAST: 'Previsione',
    ALL: 'Tutti',
    ELECTRICITY: 'Elettricità',
    GAS: 'Gas',
    WATER: 'Acqua',
    METER: 'CONTATORE',
    SavingMeter: 'Risparmio da contatore',
    BREAKDOWNMETER: 'Cons. da contat.',
    BREAKDOWNBYAREAS: 'Dettaglio per aree',
    BREAKDOWNBYEQUIPMENTTYPE: 'Dettaglio per tipo di apparecchiatura',
    CONSUMPTIONBYUTILITIES: 'Cons. per servizi',
    ENERGYBREAKDOWNOFUTILITY: 'Dettaglio dei servizi',
    ENERGYBREAKDOWNBYMETERS: 'Dettaglio per contatori',
    WATERBREAKDOWNBYLIVEMETERS: 'Suddivisione per contatori in tempo reale',
    BREAKDOWNOFUTILITY: 'Dettaglio addebiti per servizio',
    breakdownUtility: 'Dettaglio per servizi',
    breakdownCarbon: 'Dettaglio contatori',
    breakdownCarbonScopeOne: 'Dettaglio per categoria',
    breakdownFuel: 'Dettaglio per tipi di carburante',
    breakdownAreas: 'Dettaglio per aree',
    areasHeader: ' Aree',
    metersHeader: 'Contatori',
    areasSubHeaders:
      "La seguente analisi sull'utilizzo di elettricità si basa sulle aree e per la durata selezionata.",
    baselinebutton: 'Crea linea di riferimento',
    LAST_BASELINE_TRAINED_DATE:
      'Ultima formazione di riferimento effettuata il',
    apply: 'Applica',
    back: 'Indietro',
    baselinetraning: 'Formazione linea di riferimento',
    chooseTrainingDateRange: 'Scegliere intervallo di date di formazione',
    applyBaselineFrom: 'Applica riferimento da',
    historicDataTooltip:
      'Per i dati storici caricati, la linea di riferimento sarà visibile per gli ultimi 15 giorni sul dashboard e nei report.',
    excludeSpecificDateRangeQ: 'Escludere uno intervallo di date specifico?',
    excludeDateRange: 'Escludi intervallo di date',
    howitworks: 'Come funziona?',
    howitworksone:
      'Tutti i dati del contatore caricati saranno utilizzati per formare un modello di riferimento di buona qualità',
    howitworkstwo:
      'I dati di riferimento verranno visualizzati sul Dashboard e nei report degli ultimi 15 giorni a partire dalla data di caricamento',
    howitworksthree:
      'Per ottenere i migliori risultati di base, si consiglia di utilizzare 12 mesi di dati',
    howitworksfour:
      'Per il training del modello sono necessari almeno 30 giorni di dati',
    howitworksfive:
      'Viene applicata la formazione della linea di riferimento ai dati di tutti i contatori del sito',
    howitworkssix:
      'Quando si riforma il modello di riferimento, il modello esistente verrà sostituito in base al nuovo periodo di formazione del riferimento',
    baselinedaterangeheader: 'Scegliere un periodo di formazione base',
    baselinedaterangesubheader:
      "Selezionare l'intervallo di date per il modello di riferimento, se si desidera includere o escludere un periodo specifico.",
    redirectmsg1: 'Si verrà reindirizzati tra',
    redirectmsg2: 'sec.',
    uploadingmsg:
      "Attendere l'avvio del processo per formare il modello di riferimento, poi verrà inviata una notifica per e-mail una volta completato.",
    meterSubHeaders:
      'La tabella fornisce una suddivisione per contatori presenti nel sito insieme a vari KPI.',
    breakdownCarbonSites: 'Emissioni di carbonio per sito ({count})',
    ENERGYUSAGE: 'Consumo energetico',
    ENERGYUSAGECONSUMPTION: 'Consumo',
    USAGEConsumption: 'Consumo',
    WATERUSAGE: "Utilizzo dell'acqua",
    NILMTOOLTIPHEADER: 'Monitoraggio del carico non intrusivo (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Disaggregazione energetica',
    ENERGYUSAGEOVERVIEW: 'Profilo utilizzo energia',
    CONSUMPTIONOVERVIEW: 'Profilo di consumo',
    LOADING: 'Caricamento in corso',
    SUBMITTING: 'Sto inviando',
    NODATAAVAILABLE: 'Zero dati per le date selezionate',
    UTILITYYEAROUTOFRANGE: 'Selezionare un intervallo di date entro un anno',
    NOTSUBSCRIBED: 'Non abbonato',
    CONNECTIONERROR: 'Impossibile connettersi a servizio. Riprovare',
    CONNECTIONERRORTITLE: 'Errore di connessione!',
    WATERTOOLTIPHEADER: "Consumo d'acqua",
    CARBONSAVINGSMETERHEADER: 'Emissioni per categoria',
    CARBONKPIDETAILS: 'Emissioni di carbonio per',
    ENERGYUSAGEDETAILS: 'Utilizzo energia per',
    WATERUSAGEDETAILS: "Utilizzo dell'acqua per",
    CarbonSavingMeter: 'Risparmi per servizio',
    SITENAMESHEADER: 'Dettaglio per siti',
    CARBONTOOLTIPHEADER: 'Emissioni di carbonio',
    GASTOOLTIPHEADER: 'Risparmio energetico gas',
    ALLTOOLTIPHEADER: 'Risparmio energetico',
    METEROVERVIEW: 'Profilo contatore',
    METERANALYSIS: 'Analisi contatore',
    ID: 'ID',
    TYPE: 'Tipo',
    DEVIATION: 'Deviazione ',
    HIGH: 'Alta({unit})',
    HIGHWITHOUTUNIT: 'Alto',
    LOW: 'Bassa({unit})',
    LOWWITHNOUNIT: 'Basso',
    ENERGY: 'Energia({unit})',
    ENERGYNOUNIT: 'Energia',
    CHANGE: 'Modifica',
    CARBONTAB: 'Carbonio (CO2e)',
    ENERGYTAB: 'Energia',
    WATERTAB: 'Acqua',
    EUITAB: 'EUI',
    UTILITYCOST: 'Servizio',
    actualConsumption: 'CONSUMO EFFETTIVO',
    actualCons: 'CONS. EFFETT.',
    baselineConsumption: 'CONSUMO DI RIFERIMENTO',
    baselineCons: 'CONS. DI RIFER.',
    ConsumptionSavingsPercentage: 'CONS. % RISPARMI',
    ConsumptionChange: 'CONS. MODIFICA',
    ConsSavings: 'CONS. RISPARMI',
    utiltactualCost: 'COSTO EFFETTIVO',
    utilpreviousCost: 'COSTO PRECEDENTE',
    SavingsPercentage: '% RISPARMI',
    utilchange: 'MODIFICA',
    NODATA: 'Nessun dato',
    ENERGYKPIDETAILS: 'Prestazioni elettricità per',
    ENERGYPERFORMANCEALL: 'Prestazioni energetiche',
    NILMENERGYUSAGE: 'Consumo energetico',
    NILMENERGYUSAGESUBHEADER:
      'Il grafico mostra il consumo di energia nel periodo selezionato',
    ALLKPICARDDETAILS: 'Prestazioni energetiche per',
    WATERCONSUMPTIOND: 'Consumo acqua per',
    ENERGYCONSUMPTIONMETER: 'Consumo a contatore',
    WATERCONSUMPTION: "Consumo d'acqua",
    ALLUTILITIES: 'Tutti i servizi',
    ALLEnergySources: 'Tutte le fonti di energia',
    WaterPerformance: 'Prestazioni acqua',
    WaterOverview: "Panoramica dell'acqua",
    GASPERFORMANCE: 'Prestazioni gas per',
    GASPERFORMANCEDETAILS: 'Prestazioni gas',
    WATERPERFORMANCEDETAILS: 'Prestazioni acqua',
    SEWERAGEPERFORMANCE: 'Prestazioni scarichi fognari',
    ALLSAVINGSBYUTILITY: 'Risparmi BTU per servizio',
    TOTALENERGYCOST: 'Costo energetico totale',
    TOTALSAVINGS: 'Risparmio totale',
    TOTALFOOTSPRINT: 'Impronta totale',
    INTEGRATIONTYPE: 'TIPO INTEGRAZIONE',
    UTILITYPROVIDER: 'FORNITORE DI SERVIZI',
    ACCOUNTNUMBER: 'NUMERO CONTO',
    STATUS: 'STATO',
    UDSSTATUS: 'Stato DS mensile',
    IDSSTATUS: 'Stato DS a intervallo',
    ACTIONS: 'AZIONI',
    SERVICESOVERVIEW: 'Profilo servizi',
    AddService: 'AGGIUNGI SERVIZIO',
    AllServices: 'Tutti i servizi',
    Active: 'Attivo',
    Inactive: 'Inattivo',
    Sewerage: 'Scarichi fognari',
    ServiceProvider: 'Fornitori di servizi',
    AccountNumber: 'Numero conto',
    CANCEL: 'ANNULLA',
    SELECTALL: 'Seleziona tutto',
    SEARCH: 'Cerca',
    SHOWACCOUNTNUMBERS: 'Mostra tutti i numeri di account',
    BACK: 'INDIETRO',
    SUBMIT: 'INVIA',
    Complete: 'COMPLETO',
    DONE: 'FINE',
    Utillity: 'Servizio',
    AllUtilityService: 'Tutti i servizi',
    Weather: 'Meteo',
    WeatherServices: 'Servizi meteo',
    Weatherdata: 'I dati meteo possono essere integrati ai conti',
    CONFIGURE: 'CONFIGURAZIONE',
    METERID: 'ID CONTATORE',
    SERVICETYPE: 'TIPO SERVIZIO',
    METERINGPURPOSE: 'SCOPO DELLA MISURAZIONE',
    SITESETTINGS: 'Impostazioni del sito',
    SERVICESINTEGRATION: 'Servizi',
    USERMANAGEMENT: 'Gestione utenti',
    GENERALSETTINGS: 'Impostazioni generali',
    UTILITYBILLTOOLTIPHEADER: 'Bolletta',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Prestazioni dei servizi',
    ELECTRICITYTOOLTIPHEADER: 'Risparmio energetico elettricità',
    WATERTOOLTIPCONTENT:
      "Confronto del consumo d'acqua per la durata selezionata dai valori effettivi rispetto ai dati dell'anno di riferimento",
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      "Costo calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. Nota: il costo è calcolato in base ai mesi di calendario e non è specifico dei periodi di fatturazione delle utenze.",
    UTILITYBILLTOOLTIPCONTENT:
      "Utilizzo e costo calcolati per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. Nota: il costo è calcolato in base ai mesi di calendario e non è specifico dei periodi di fatturazione delle utenze.",
    CARBONTOOLTIPCONTENT:
      "Emissioni calcolate per la durata selezionata in base ai valori effettivi rispetto ai dati dell'anno precedente. ",
    DATANEEDEDCONTENT:
      'Dati ambito 1 mancanti, rivedere e aggiornare i dati ogni mese',
    CARBONTOOLTIPSECONDCONTENT:
      "I calcoli della CO2 in tempo reale si basano sul contatore principale e i calcoli precisi del carbonio sono aggiornati dopo l'emissione delle bollette.",
    CARBONTOOLTIPSUTILITY:
      "Emissioni calcolate per la durata selezionata in base ai valori effettivi rispetto ai dati dell'anno precedente. I calcoli effettivi delle emissioni di carbonio si basano sulla fattura di servizi fornita.",
    CARBONTOOLTIPLIVE:
      "Emissioni calcolate per la durata selezionata in base ai valori effettivi del contatore locale rispetto ai dati dell'anno precedente. I calcoli della C02 in tempo reale si basano sul contatore principale.",
    CARBONTOOLTIPINTRVAL:
      "Emissioni calcolate per la durata selezionata in base ai valori effettivi rispetto ai dati dell'anno precedente. I calcoli effettivi di emissione di carbonio sono basati sui dati dell'intervallo di utilizzo.",
    ELECTRICITYTOOLTIPCONTENT:
      "Risparmi sull'elettricità calcolati per la durata selezionata in base ai valori effettivi rispetto ai dati dell'anno di riferimento",
    DATANEEDED1:
      "Dati insufficienti - I dati dell'ambito 1 devono essere aggiornati ogni mese.",
    GASTOOLTIPCONTENT:
      "Risparmio per gas calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno di riferimento",
    ALLTOOLTIPCONTENT:
      " Risparmi calcolati per la durata selezionata dai valori effettivi rispetto ai dati dell'anno di riferimento",
    UTILITYVIEWDETAILSTOOLTIP:
      "Utilizzo e costo calcolati per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. Nota: il consumo e il costo sono calcolati in base a mesi di calendario e non specifici per i periodi di fatturazione della fornitura.",
    EMAASENERGYUSAGETOOLTIP:
      "Uso calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno di riferimento",
    EMAASENERGYUSAGETOOLTIPPREV:
      "Uso calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente",
    EMAASCONSUMPTIONTOOLTIP:
      "Utilizzo calcolato per la durata selezionata in base ai valori effettivi rispetto ai dati di base o dell'anno precedente",
    EMAASWATEROVERVIEWTOOLTIP:
      "Utilizzo calcolato per la durata selezionata in base ai valori effettivi rispetto ai dati dell'anno precedente",
    EMAASNILMTOOLTIP:
      'Determinare la composizione del consumo di energia elettrica del sito in base ai tipi di apparecchiatura',
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Risparmi totali sui costi dei servizi energetici per la durata selezionata',
    PORTFOLIOSUMMARYEUITOOLTIP:
      "L'UEI è un indicatore dell'efficienza energetica del progetto e/o delle operazioni di un edificio. L'EUI viene misurato come aggregazione energetica del portafoglio diviso per il totale mq del portafoglio in un anno.",
    SITESUMMARYEUITOOLTIP:
      "L'UEI è un indicatore dell'efficienza energetica della progettazione e/o delle operazioni di un edificio. L'EUI viene misurato come aggregazione energetica del sito degli ultimi 12 mesi diviso per la superficie totale lorda del sito.",
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (Intensità utilizzo energia)',
    SUMMARYEUITOOLTIPHEADERFORSITE: 'EUI (Intensità utilizzo energia) - {date}',
    PROVIDERLISTPLACEHOLDER: 'Cerca dettagli fornitore',
    PORTFOLIOSUMMARYHEADER: 'Profilo carbonio e energia',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Ultimo aggiornamento: {date}',
    AIModelDetails: 'Dettagli modello IA',
    DATAUPLOAD: 'Caricamento dati',
    ADDFUEL: 'Aggiungi carburante',
    ADD: 'Aggiungi',
    ADDCOMPOUND: 'Aggiungi composto',
    ADDMETEREDGAS: 'Aggiungi gas misurato',
    ADDSCOPETWO: 'Aggiungi ambito 2',
    EXCEEDEDLIMIT: 'Superato il limite massimo di 4',
    DETAILS: 'Dettagli',
    DATAUPLOADDETAILS:
      "Accedere a tutte le funzioni che richiedono l'immissione manuale / caricamento di file di dati",
    DATAUPLOADCECARDSUBTITLE:
      "Monitorare l'utilizzo delle emissioni di carbonio di ambito 1 per raggiungere gli obiettivi di sostenibilità aziendale.",
    DATAUPLOADCARBONESUBTITLE:
      "In questa pagina è visualizzata una tabella completa in cui sono mostrati i vari combustibili, le relative quantità e i fattori di emissione di carbonio associati per l'anno selezionato.",
    SCOPEONETWOSUBTITLE:
      "In questa pagina viene presentata una tabella dettagliata che mostra le emissioni di ambito 1 (emissioni dirette, inclusi la combustione stazionaria e i refrigeranti) e di ambito 2 (emissioni indirette da energia elettrica), insieme alle relative quantità e fattori di emissione di carbonio per l'anno prescelto.",
    METERDATASUBHEADER:
      'Accedere a tutti i file di dati caricati per i dati del contatore.',
    DATAMISSINGALERTS: 'Avvisi per dati mancanti',
    UPLOAD: 'Caricamento in blocco',
    UPLOADTOPADD: 'Carica file',
    PUBLISHFILE: 'Pubblica',
    BASELINEFILE: 'Riferimento',
    BASELINE_SUCCESS: 'Formazione di base avviata con successo',
    UPLOADTOP: 'Carica',
    UPLOADFILE: 'CARICA',
    NAME: 'Nome',
    DATATYPE: 'Tipo di dati',
    CREATEDON: 'Data creazione',
    DATEOFUPLOAD: 'Data di caricamento',
    ALLUPLOADS: 'Tutti i caricamenti',
    STATIONARYCOMBUSTION: 'Combustione stazionaria',
    REFRIGERANTS: 'Refrigeranti',
    WHEATHERDATA: 'Dati meteo',
    UTILITYBILL: 'Bolletta',
    SCOPE2: 'Ambito 2',
    METEREDGAS: 'Gas contabilizzato',
    NOFILESADDEDHEADER: 'Non sono ancora stati aggiunti file.',
    NOFILESADDEDMESSAGE:
      'Iniziare caricando dati su meteo, utenza o dati punto',
    UPLOADBUTTON: 'Carica',
    METER_DATA: 'Dati contatore',
    UTILITY_BILL: 'Bolletta',
    FUEL_NAME: 'Nome carburante',
    SEARCHFOR: 'Cerca',
    EnergyManagementSiteDashboardPortfolioTitle:
      "Panoramica del carbonio e dell'energia",
    CHOOSEDATATYPEMESSAGE:
      'Scegliere il tipo di dati di seguito per scaricare il modello e procedere al passo successivo per caricare i file.',
    UPLOADMETERDATASTEPONEMESSAGE:
      'Passaggio 1: scaricare il modello dati del contatore',
    UPLOADMETERDATA: 'Carica dati contatore',
    FILEUPLOADNOTE:
      'Nota: è accettato solo il file {type} e ogni file non deve superare {size} mb.',
    UPDATEDFILEUPLOADNOTE:
      'Nota: solo i file CSV sono accettati e ogni file non deve superare 5 Mb',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Istruzioni per il caricamento del modello.',
    INSTRUCTIONTEMPLATEONE:
      'Iniziare caricando i dati storici di lettura del contatore utilizzando il modello CSV fornito.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      "Verificare che i valori dei dati caricati siano presenti nell'unità configurata in RBM per i contatori",
    INSTRUCTIONTEMPLATEFIVE:
      'Durante il processo di caricamento è possibile caricare fino a 10 file, per una dimensione totale del file combinato che non supera i 1,5 GB.',
    INSTRUCTIONTEMPLATETWO:
      "L'utente può caricare dati del valore massimo di 2 anni di dati con intervallo di 1, 3, 5 o 15 minuti di dimensione del file fino a 1,5 gb",
    INSTRUCTIONTEMPLATETHREE:
      'Il dashboard e i report visualizzano i dati storici del contatore degli ultimi 15 giorni e tutti i dati del contatore caricati verranno utilizzati per creare un modello di riferimento di buona qualità',
    INSTRUCTIONTEMPLATEFOUR: 'Visualizza esempio di modello CSV riempito',
    UPLOAD_PROGRESS_IN_TOAST:
      'Lo stato di caricamento è visibile nel widget nella parte inferiore della schermata.',
    PUBLISHMODALHEADER: 'Pronto a pubblicare?',
    ERRORINPUBLISHING:
      'Si è verificato un errore durante la pubblicazione dei file. Riprovare più tardi',
    WARNINGNOTIFICATIONFORPUBLISH: 'È in corso il caricamento di altri file',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      'Si preferisce attendere prima della pubblicazione o continuare a pubblicare i file {filesToPublish}?',
    NOTEFORPUBLISHFILE:
      'Nota: una volta completata la pubblicazione, invieremo una notifica via e-mail e mostreremo i dati storici del contatore solo per gli ultimi 15 giorni nel dashboard o nei report.',
    INSTRUCTIONFORPUBLISHFILE: 'Pubblicare i file caricati?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Scarica modello CSV dati contatore',
    PUBLISHBUTTON: 'Sì, pubblica',
    METERDATAPUBLISHINGMSG:
      'Attendere la pubblicazione dei dati. Una volta completati, ti invieremo una notifica via e-mail.',
    METERDATAUPLOADFAILED:
      'Caricamento del file non riuscito: {fileName}. Riprovare in seguito',
    METERDATAUPLOADSUCCESS: 'File: {fileName} caricato correttamente',
    NOBUTTON: 'No',
    METERUPLOADINSTRUCTIONTITLE:
      'Istruzioni per il caricamento dei dati del contatore',
    METERUPLOADDOWNLOADCSV: 'Scarica modello CSV',
    METERUPLOADDOWNLOADEXCEL: ' Scarica modello CSV',
    METERUPLOADINSTRUCTIONONE:
      'Iniziare caricando i dati storici di lettura del contatore utilizzando il modello CSV fornito. ',
    METERUPLOADINSTRUCTIONFOUR:
      'Assicurarsi che i dati scaricati dal supervisore non superino 1,5 GB. Consultare il documento fornito per le preferenze sulla dimensione dei dati. ',
    METERDATAEXCELDOWNLOAD: 'Scarica stima Excel',
    METERUPLOADINSTRUCTIONTWO:
      'Dopo aver caricato i file CSV per tutti/gli indicatori del sito desiderati, fare clic sul pulsante "Pubblica" per elaborare e ricaricare i dati cronologici.',
    METERUPLOADINSTRUCTIONTHREE:
      'Per stabilire un riferimento, fare clic su "Azione riferimento" e specificare l\'intervallo di dati desiderato. Forge AI formerà il riferimento utilizzando i dati storici pubblicati che sono disponibili.',
    CHOOSEDATATYPE: 'Scegliere il tipo di dati',
    NEXTUPLOAD: 'Successivo-Caricamento',
    UPLOADDATA: 'Carica dati',
    ADDNEWFUEL: 'Aggiungi nuovo combustibile a',
    ADDNEWCOMPOUND: 'Aggiungi nuovo composto a',
    MANUALINPUT: 'IMMISSIONE MANUALE',
    UPLOADDATACAPS: 'CARICA DATI',
    ADDNEWFUELSUB:
      'Scegliere tra le opzioni sottostanti per inserire o caricare manualmente un modello',
    SCOPEONESC: 'Combustione stazionaria: aggiungere combustibile',
    SCOEONEREF: 'Refrigeranti: aggiungere composti',
    SCOPETWO: 'Ambito 2',
    UPLOADING: 'Caricamento',
    FILES: 'file',
    FILE: 'file',
    UPLOADINGMESSAGE1:
      'Le informazioni relative alla progressione e allo stato di caricamento di questi file sono visibili nella notifica toast che si trova nella parte inferiore centrale della schermata.',
    REDIRECTMESSAGE1: 'Reindirizzo tra',
    REDIRECTMESSAGE1OCR: 'Presto sarete reindirizzati',
    REDIRECTMESSAGE2: 'sec.',
    UPLOADFILES: 'Carica file per',
    UPLOADMETERDATASTEPTWOMESSAGE:
      'Passaggio 2: caricare i file per i dati del contatore',
    UPLOADNOTE:
      'Sono accettati solo file {type} e per ogni file non si devono superare {size} mb',
    UPDATEDUPLOADNOTE:
      'Accettato solo un file CSV e il file non deve superare 1,5 GB',
    UPDATEDUPLOADNOTESUB: '(è possibile solo un caricamento alla volta)',
    INSTRUCTIONBUTTON: 'Esempio di modello CSV riempito',
    FILEUPLOADPLACEHOLDER: 'Trascinare e scaricare i file qui',
    SINGLEFILEUPLOADPLACEHOLDER: 'Trascina e rilascia il file qui',
    TOTALSIZEEXCEEDSERROR: 'La dimensione totale supera il limite (1,5 GB)',
    NUMBEROFFILEALLOWED: 'È possibile caricare fino a 10 file',
    FILEUPLOADPLACEHOLDERONLYONEFILE:
      '(è possibile solo un caricamento alla volta)',
    REMOVE: 'Elimina',
    CHOOSESERVICE: 'Scelta servizio',
    CONNECT: 'Connetti',
    NEXT: 'Avanti',
    CHOOSEUTILITYTYPE:
      'Selezionare un fornitore di servizi, fornire credenziali e dettagli del conto per integrare i dati.',
    CHOOSEUTILITYTYPEMANUAL:
      'Immettere il fornitore di servizi e i dettagli del conto per caricare manualmente i dati delle utenze.',
    EDITDETAILNOTE:
      'Immettere di seguito i dettagli corretti relativi al conto e al contatore. Quindi, fare clic su "Invio" per aggiornarli e salvarli.',
    EDITDETAILWHENBILLEXISTS:
      'Immettere di seguito i dettagli corretti relativi al conto e al contatore. Quindi, fare clic su "Invio" per aggiornarli e salvarli.',
    SEARCHPROVIDER: 'Cerca fornitore di servizi',
    CONTACTSUPPORT:
      'Impossibile trovare il fornitore di servizi? Rivolgersi al team di assistenza Honeywell.',
    UTILITYPROVIDERLABEL: 'Fornitore di servizi',
    SERVICEPROVIDERNAME: 'FORNITORE DEL SERVIZIO',
    INTEGRATIONTYPENAME: 'TIPO INTEGRAZIONE',
    UTILITYSERVICES: 'Servizi di utilità',
    UtilityHandoffNotification:
      "Il tipo di integrazione del {manualCount} Conto del servizio può essere convertito da 'Manuale' a 'Automatico'. In questo modo sarà possibile aggiornare automaticamente le fatture delle utility senza necessità di intervento da parte dell'utente. Trovare l'opzione nel menu 'Azioni' nella tabella seguente.",
    UTILITYSERVICESDETAILS:
      'Integrare e gestire più servizi per ottenere i dati in modo automatico, rapido e intelligente.',
    ADDUTILITYSERVICE: 'Aggiungi servizio di utenza',
    ADDUTILITYTYPE: "Tipo di integrazione dell'utenza",
    AUTOMATEDTEXT:
      'Fornire le credenziali del conto del "fornitore di servizi" per abilitare il recupero automatico mensile dei dati della bolletta.',
    MANUALTEXT:
      'Se non si dispone delle credenziali del fornitore di servizi, è necessario aggiornare manualmente le informazioni sulla bolletta ogni mese.',
    MANUAL: 'Manuale',
    AUTOMATED: 'Automatico',
    ADD_UTILITY_SERVICE: 'Aggiungi servizio di utenza',
    UTILITYTYPES: 'TIPI DI UTILITÀ',
    NOACCOUNTADDEDHEADER: 'Nessun conto utilità aggiunto.',
    NOACCOUNTADDEDMESSAGE:
      'Iniziare integrando i conti per gestire le fatture e le tariffe.',
    ADDACCOUNTNUMBER: 'Aggiungi',
    SELECTUTILITY: "Seleziona un'utenza",
    ACCNUMBER: 'Numero conto*',
    UTILITYPROVIDERERROR:
      'Fornitore servizi non trovato. Per assistenza nella conversione di questo account, contattare il proprio Manager Honeywell.',
    PASSWORD: 'Password*',
    USERNAME: 'Nome utente*',
    SIGNIN: 'Firma',
    UTILITYPROVIDERTOOLTIPTXT:
      'Immettere il nome del fornitore di servizi come indicato nella bolletta.',
    VERIFICATIONINPROCESS: 'Verifica in corso',
    VERIFICATIONMSSG1: 'La verifica conto richiede 2/3 giorni.',
    UPDATECREDENTIALS: 'Aggiorna credenziali',
    UPDATECREDENTIALSNOTE:
      'Inserire la password aggiornata "Nome fornitore del servizio" per attivare il conto.',
    ENTERCREDENTIALS: 'Immettere credenziali',
    ENTERCREDENTIALSNOTE:
      'Usare le credenziali "Nome fornitore del servizio" per collegare il conto.',
    PLEASEUSESERVICE:
      'Usare le credenziali "Fornitore del servizio" per collegare il conto.',
    FILEEMPTYERRORMSG: 'Errore! Il file è vuoto. Caricare di nuovo.',
    FILESIZEERRORMSG:
      'La dimensione del file supera 50 MB. Ridurre la dimensione del file e riprovare.',
    FILEMAXSIZEERRORMSG:
      'La dimensione del file supera {maxSize}. Ridurre la dimensione del file e riprovare.',
    FILEHEADERERROR:
      'Il file contiene intestazioni non valide. Usare il modello fornito e caricare di nuovo.',
    CSVFILEINVALID:
      'I dati/nome del file CSV caricato non sono validi. Controllare il file e riprovare.',
    CSVFILEINVALIDNAME:
      'Il file CSV caricato non è valido. Qualsiasi carattere speciale o estensione multipla non è consentito.',
    DEACTIVATEACCOUNT: 'Disattiva account',
    DEACTIVATEUDSACCOUNT: 'Disattivare il servizio dati mensile',
    DEACTIVATEIDSACCOUNT: 'Disattivare IDS (Interval Data Service)',
    REACTIVATEACCOUNT: 'Riattivare il conto',
    REACTIVATEIDSACCOUNT: 'Riattivare IDS (Interval Data Service)',
    CONVERTTOAUTOMATIC: "Convertire in 'Automatico'",
    MANAGEBILLDETAILS: 'Gestisci dettagli bolletta',
    MANAGETARIFFDETAILS: 'Gestisci tariffe',
    EDITACCOUNTDETAILS: 'Modifica dettagli account',
    EDIT_ACCOUNT_DETAILS: 'Modifica dettagli conto',
    ADD_METERS: 'Aggiungi contatori',
    UTILITY_TYPES: 'TIPI DI UTILITÀ',
    CONVERT_INTEGRATION_TYPE: 'Converti Tipo di Integrazione',
    ACCOUNT_NUMBER: 'Numero conto',
    BILLING_CYCLE: 'Ciclo di fatturazione',
    PERIOD: 'Periodo',
    EDITACCOUNTDETAILSTOOLTIP:
      "Nel caso non vi fossero fatture caricate, l'utente può modificare tutti i campi.",
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      "All'utente è consentito modificare il numero di account",
    CONVERTINTRGRATIONTYPE: "Convertire in 'Automatico'",
    ENABLEIDS: 'Abilita IDS (Interval Data Service)',
    DELETE: 'Elimina',
    DELETING: 'Eliminazione',
    DEACTIVATECONFIRMATIONNOTE: 'Disattivare il numero di conto?',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      'Sei sicuro di voler disattivare IDS (Interval Data Service) per il numero di conto',

    REACTIVATECONFIRMATIONNOTE: 'Riattivare il numero di conto?',
    REACTIVATEIDSCONFIRMATIONNOTE:
      'Sei sicuro di voler riattivare IDS (Interval Data Service) per il numero di conto',
    DEACTIVATEUTILITYACCOUNTMSSG:
      "Una volta disattivato il conto, l'applicazione non sarà in grado di recuperare automaticamente le informazioni relative alla bolletta e si memorizzano solo i dati storici.",
    DEACTIVATEIDSACCOUNTMSSG:
      "Una volta disattivato IDS, l'applicazione non sarà in grado di recuperare automaticamente i dati dell'intervallo di utilizzo e verranno memorizzati solo i dati storici.",
    REACTIVATEUTILITYACCOUNTMSSG:
      "Una volta riattivato il conto, l'applicazione recupera automaticamente le informazioni sulla bolletta.",
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      "Una volta riattivato IDS, l'applicazione recupera automaticamente i dati dell'intervallo di utilizzo.",
    YES: 'Sì',
    NO: 'No',
    REVERIFYNOTE:
      'Inserire le credenziali "Fornitore del servizio" per collegare il conto.',
    REVERIFYHEADER: 'Verificare credenziali e numero di account',
    REVERIFY: 'Verifica di nuovo',
    UPDATE: 'Aggiorna',
    REENROLL: 'Riattiva account',
    save: 'SALVA',
    ACCOUNTMISSINGHEADER: 'Aggiorna numero di conto',
    ACCOUNTMISSINGNOTE:
      'Inserire le credenziali "Fornitore del servizio" e il numero di conto per collegare il conto.',
    SHOWMORE: 'Mostra di più',
    NORESULTS: 'Nessun risultato trovato.',
    BREAKDOWNBYSITE: 'Ripartizione per sito ({count})',
    PORTFOLIOENERGY: 'Energia',
    PORTFOLIOENERGYCONS: 'Cons. energ.',
    PORTFOLIOCONSUMTION: 'Consumo',
    PORTFOLIOWATER: 'Acqua',
    PORTFOLIOWATERCONS: "Consumo d'acqua",
    ENERGYUSAGEBYSITE: 'Utilizzo di energia per siti ({count})',
    SITEWITHDATA: '* Solo i siti con dati sono mostrati nella tabella',
    ELECTRICITYUSAGEBYSITE: 'Utilizzo di energia elettrica per siti ({count})',
    GASUSAGEBYSITE: 'Utilizzo del gas per siti ({count})',
    WATERUSAGEBYSITE: "Utilizzo dell'acqua per siti ({count})",
    ENERGYOPTIMIZATION: "Ottimizzazione dell'edificio intelligente",
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Energy Optimization (EO)',
    ENERGYOPTIMIZATIONSAVINGS: 'Risparmio Eo',
    EOSETTINGSUBTITLE:
      "EO monitora, misura e ottimizza continuamente l'HVAC nell'edificio, in relazione al consumo più basso di energia, in tutte le situazioni, riducendo al minimo il consumo di energia per il riscaldamento e il raffreddamento in modo continuativo.",
    EOSETTINGMODALHEADER: 'Ottimizzazione energetica inattiva?',
    EOSETINGMODALCONTENT:
      "L'ottimizzazione dell'edificio intelligente non monitorerà, misurerà e ottimizzerà continuamente l'HVAC nel vostro impianto per via del consumo minimo di energia.",
    EOSETINGMODALCONTENTSUB: "Disattivare l'ottimizzazione energetica?",
    EOENABLETITLE: "Abilitare l'ottimizzazione energetica per questo sito.",
    EOSTATUSMESSAGESUCCESS:
      "Ottimizzazione dell'edificio intelligente abilitata correttamente per questo sito.",
    EOSTATUSMESSAGEERROR:
      "Ottimizzazione dell'edificio intelligente disabilitata correttamente per questo sito.",
    EOSETTINGNODATAAVAILABLE:
      "Contattare l'amministratore del sistema. Configurazione non completata.",
    CURRENTEOSTATUS: 'Stato EO corrente: ',
    ON: 'On',
    OFFMANUALSWITCHEDOFF: 'Spento-Manuale Spento',
    OFFLINE: 'Offline',
    EONotOptimizing: 'EO non sta ottimizzando',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Spento-Pianificato Spento per Miglioramento del Riferimento',
    SwitchedOfffromCloud: 'Spento da Cloud',
    SwitchedOfffromSite: 'Spento da Sito',
    EOON:
      'Lo stato EO On indica la strategia di ottimizzazione corrente in uso',
    EOMANUALSWITHCHEDOFF:
      'set-point non è stato applicato da quando EO è stato spento manualmente',
    PLANNEDOFFFORBASELINE:
      'EO è pianificato per essere spento per migliorare il riferimento',
    STATUSNOTAVAILABLE: 'Stato non disponibile',
    STATUSNOTAVAILABLETOOLTIP:
      'I dettagli dello stato non sono presenti in questo momento. Contattare il team di supporto Honeywell -connectedbuildingsupport@honeywell.com per risolvere questa condizione',
    EOOFFLINE:
      'Lo stato EO Off indica la strategia di ottimizzazione non in uso a causa di una mancata ottimizzazione',
    SwitchedOfffromCloudToolTip:
      "EO è stato spento manualmente da Cloud. Contattare il supporto per la connessione a edifici Honeywell connectedbuildingsupport@honeywell.com per riattivare l'EO",
    SwitchedOfffromSiiteToolTip:
      "EO è stato spento manualmente dall'utente dal sito",
    EOSavings: " Risparmi dall'ottimizzazione intelligente dell'edificio",
    EOUtility_all: 'Tutti le utenze',
    EOUtility_electricity: 'Elettricità',
    EOUtility_gas: 'Gas',
    EOUtility_steam: 'Vapore',
    EOUtility_chilledwater: 'Acqua refrigerata',
    EOUtility_hotwater: 'Acqua calda',
    inactiveDays: 'Giorni di inattività',
    inactiveDay: 'Giorno inattivo',
    excludedDays: 'Giorni esclusi',
    excludedDay: 'Giorno escluso',
    activeHours: 'Orario di attività',
    activeDay: 'Giorno attivo',
    savingsSummaryEO:
      'Risparmi stimati (con {opertionalPercentage}% tempo operativo EO)',
    operationalTimeEO: 'Con {opertionalPercentage}% tempo operativo EO',
    timeUsedForBaselining:
      '{baseline}% del tempo utilizzato per la formazione di base',
    siteComfort: 'Comfort del sito',
    activeStrategyStatus: 'Attivo',
    inactiveStrategyStatus: 'Inattivo',
    lastUpdated: 'Ultimo aggiornamento:',
    CALCULATED: 'Riferimento',
    ESTIMATEDSAVINGS: 'Risparmio stimato',
    OPPORTUNITYFROMEO: 'Opportunità da EO',
    EMAASEOSTATETOOLTIP:
      'Stato attivo o inattivo indica la strategia di ottimizzazione corrente in uso.',
    EOSAVINGTOOLTIP:
      "Risparmi energetici quando è stata eseguita l'ottimizzazione dell'edificio intelligente rispetto al consumo energetico calcolato.",
    EOSAVINGONENABLE: 'Risparmi nei giorni con IBO attivata',
    EOSAVINGENTIREPERIOD: 'Risparmi per tutto il periodo',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      "Nessun risparmio nell'intervallo di tempo selezionato. Per conoscere i risparmi stimati, considera di estendere la durata selezionata a un periodo più lungo.",
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      "Uso calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno di riferimento. EUI calcolata utilizzando i dati energetici delle bollette.",
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      "Utilizzo calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. EUI calcolata utilizzando i dati dell'energia elettrica delle bollette.",
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      "Utilizzo calcolato per la durata selezionata in base ai valori effettivi rispetto ai dati di base o dell'anno precedente. EUI calcolata utilizzando i dati dell'energia elettrica delle bollette.",
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      "L'utilizzo è calcolato per il periodo selezionato in base ai valori effettivi, rispetto ai dati precedenti o di riferimento per utenza e il contatore in tempo reale. L'utilizzo mensile si basa sul consumo di energia giornaliera media sulla scorta delle bollette, normalizzato per mesi completi quando il periodo di fatturazione copre due mesi.",
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      "L'utilizzo è calcolato per il periodo selezionato in base ai valori effettivi, rispetto ai dati di riferimento del contatore in loco.",
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      "L'utilizzo è calcolato per il periodo selezionato in base all'effettivo, rispetto ai dati di base derivati dai dati di intervallo dell'utenza.",
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      "L'utilizzo è calcolato per il periodo selezionato in base ai valori effettivi, rispetto ai dati precedenti del contatore in loco.",
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      "L'utilizzo è calcolato per il periodo selezionato in base ai valori effettivi, rispetto ai dati del periodo precedente dalle bollette di utenza. L'utilizzo mensile è basato sull'energia giornaliera media basata sulle fatture di servizi, normalizzata per un mese intero quando la fattura si estende per due mesi.",
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Modifica',
    PORTFOLIOSITECOUNT: 'Ripartizione per sito ({count})',
    UTILITYCOSTBYSITES: '{Utility} Costo per siti ({count})',
    ALLUTILITYCOSTBYSITES: 'Costo utenze per siti ({count})',
    SOLAR: 'Solare',
    WIND: 'Vento',
    SOLARPERFORMANCE: 'Prestazioni solari',
    WINDPERFORMANCE: 'Prestazioni vento',
    UTILITYCOSTOVERVIEW: 'Profilo di costo utenza',
    DESCRIPTIONNOTIFICATION:
      "Raggiunto il numero massimo di conti di servizi per lo stesso tipo di utenza. Contattare l'amministratore per creare altri conti.",
    TITLENOTIFICATION: 'Limite conti raggiunto.',
    ENERGYUSAGECAPS: 'CONSUMO ENERGETICO',
    UPDATEERRORMESSAGE: 'Si è verificato un errore. Riprovare in seguito.',
    MANUALTOAUTOMATICCONVERSION:
      'La conversione del conto da Manuale ad Automatico è stata correttamente avviata.',
    APPLY: 'APPLICA',
    RESET: 'RESET',
    CLOSE: 'CHIUDI',
    SCOPE1FUELTYPES: 'Tipi di carburante ambito 1',
    SCOPE1FILTERSUBHEADER: 'Il filtro cambia solo la visualizzazione grafica',
    SCOPE1DATAMISSING: 'Dati ambito 1 mancanti',
    SCOPE1SHOWMISSINGDATA:
      "Esaminare i dati mancanti dell'ambito 1 e aggiornare",
    FUELGASTYPE: 'Tipo di carburante/gas',
    COMPOUNDTYPE: 'Tipo di composto',
    UTILITYTYPE: 'Tipo di servizio',
    FUELGASTYPESELECT: 'Selezionare un tipo di carburante/gas',
    COMPOUNDSELECT: 'Selezionare il tipo di composto',
    UTILITYSELECT: 'Seleziona tipo di utilità',
    EMISSIONFACTOR: 'Fattore di emissione CO2',
    SelectCategory: 'Seleziona categoria',
    UNIT: 'Unità',
    UNITSELECT: "Selezionare un'unità",
    StationaryCombustion: 'Combustione stazionaria',
    YEAR: 'Anno',
    Country: 'Paese',
    State: 'Stato ',
    YEARSELECT: 'Selezionare un anno',
    MONTH: 'Mese',
    Override: 'Sovrascrivi',
    MONTHSELECT: 'Selezionare un mese',
    ADDDATA: 'Aggiungi dati',
    NOFUELCONSUMED: 'Nessun carburante consumato ',
    NOCONSUMED: 'Nessun consumo',
    QUANTITY: 'Quantità',
    QUANTITYENTER: 'Immetti quantità',
    COSTSCOPE: 'Costi',
    COSTENTER: 'Inserisci costo',
    EDIT: 'Modifica',
    YEARCHECK: 'anno',
    MONTHERROR: 'Seleziona un mese diverso',
    SUCCESS: 'Dati aggiornati correttamente',
    CO2FACTORROOLTIPHEADER: 'Fattore di emissione CO2',
    PLEASENOTE: 'Nota: ',
    PLEASENOTETEXT:
      'il nuovo fattore delle emissioni di carbonio verrà utilizzato nel prossimo calcolo. I valori già calcolati delle emissioni di carbonio non verranno ricalcolati con il nuovo valore.',
    CO2FACTORROOLTIPCONTENT:
      "È la quantità di CO2 rilasciata nell'atmosfera per unità di energia utilizzata.",
    CO2FACTORSCCONTENT:
      "È la quantità di CO2 rilasciata nell'atmosfera per unità di energia utilizzata. Immettere un valore equivalente in kgCo2e/mmbtu per l'unità selezionata.",
    CO2FACTORRFCONTENT:
      "È la quantità di CO2 rilasciata nell'atmosfera per unità di energia utilizzata. Immettere un valore equivalente in MTCo2e/mmbtu per l'unità selezionata.",
    CO2FACTORSCOPETWOANDGASCONTENT:
      "È la quantità di CO2 rilasciata nell'atmosfera per unità di energia utilizzata. Immettere un valore equivalente per l'unità selezionata.",
    FUELTABLETEXT:
      'I tipi di carburante sotto appartengono alle emissioni di ambito 1',
    METEREDGASHEADER:
      'I tipi di servizi sotto appartengono alle emissioni di ambito 1',
    SCOPETWOHEADER:
      'I tipi di servizi sotto appartengono alle emissioni di ambito 2',
    UNITDROPDOWNNAME: 'Unità',
    COMPOUNDTABLETEXT:
      'I tipi di composti sotto appartengono alle emissioni di ambito 1',
    ENERGYCONSUMPTIONNILM: 'Consumo energia',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'Il grafico mostra il consumo di energia e la relativa suddivisione nel periodo selezionato',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE:
      'Consumo energetico per tipo di apparecchiatura',
    METERNAME: 'Nome contatore*',
    METERNUMBER: 'Numero contatore*',
    CONSUMPTIONUNIT: 'Unità di consumo',
    DEMANDUNIT: 'Unità domanda',
    CURRENCYUNIT: 'Unità di valuta',
    TOTALMETERS: 'TOTALE CONTATORI',
    METERNAMECHANGEDESCRIPTION:
      "Di seguito è riportato l'elenco degli ID contatore associati al conto",
    METERNAMEUPDATESUCCESS:
      'ID contatore: ({meterId}) è stato rinominato con successo in "({meterName})"',
    METERNAMECHARACTERS: 'Usa solo caratteri alfanumerici',
    METERNAMEMAXLENGTH: 'Lunghezza massima: {maxCh} caratteri',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Profilo di consumo ({rate})',
    DEMAND_OVERVIEW: 'Profilo della domanda {rate}',
    DEMAND: 'Domanda',
    CONSUMPTION_RATE_OVERVIEW: '{name} Profilo ({rate})',
    ELECTRICITYBLENDEDRATE: 'Tariffa elettrica mista ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Profilo dei costi ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: "Costo dell'elettricità ({rate})",
    COST: 'Profilo di consumo',
    SUMMARY: 'Riepilogo',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Gestisci colonne',
    RESET_ALL_FILTERS: 'Ripristina tutti i filtri',
    DOWNLOAD_CSV: 'Scarica CSV',
    DOWNLOAD_PDF: 'Visualizza e scarica il PDF',
    UTILITY_BILL_ANALYSIS: '{utilityName} Analisi delle fatture',
    NOTIFICATIONBOXFORMONTHLY:
      "L'analisi della bolletta dell'energia elettrica viene fornita con visualizzazioni mensili e per periodo di fatturazione.  La visualizzazione mensile calcola la bolletta dell'energia elettrica dall'inizio alla fine del mese su base proporzionale. Esempio (1 maggio 2022 - 31 maggio 2022). La visualizzazione del periodo di fatturazione corrente calcola la fattura di servizi come da ciclo di fatturazione effettivo. Esempio (22 maggio 2022 - 22 giugno 2022). Fare clic sul periodo di fatturazione per visualizzare i dati in base al ciclo di fatturazione effettivo.",
    SUMMARYTABLEAPIONGOING:
      'I richiami della tabella di riepilogo sono in fase di elaborazione in batch, fare clic dopo che tutti i dati della tabella sono stati caricati.',
    NOTIFICATIONFORBILLINGPERIOD:
      'La visualizzazione del periodo di fatturazione calcola la bolletta secondo il ciclo di fatturazione effettivo. Esempio (22 maggio 2022 - 22 giugno 2022).',
    VIEW_OVERVIEW: 'Visualizzare profilo',
    FILE_DELETED_SUCCESSFULLY: 'File eliminato con successo',
    FILE_DELETEING_ERROR:
      "Si è verificato un errore durante l'eliminazione del file. Riprovare in seguito.",
    AVG_CONSUMP_PER_MTH: 'Consumo medio mensile',
    AVG_CONSUMP_PER_DAY: 'Consumo medio al giorno',
    MTHLY_CONSUMP_PER_SQFT: 'Consumo mensile per mq.',
    EnableIDSText:
      'Immettere le credenziali per verificare il conto. Fare clic su Invia per abilitare IDS.',
    EnableIDSHeaderTxt: 'Abilita IDS (Interval Data Service)',
    EOSAVINGS: 'Risparmi EO',
    EOSUMMARY: 'Riepilogo EO'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Tipo di allarme',
    CONFIGUREALARMDESCLINE1:
      'Seleziona tipo di allarme per i contatori da configurare',
    CONFIGUREALARMDESCLINE2:
      'Selezionare il tipo di allarme contatori per attivazione allarmi, se il consumo energetico supera il riferimento entro la gamma indicata.',
    ALLMETERS: 'Tutti i contatori ',
    SEARCHALARMTYPE: 'Seleziona tipo di allarme',
    SEARCHMETERS: 'Cerca contatore',
    THRESHOLDSETTINGS: 'IMPOSTAZIONI SOGLIA',
    NOMETERSSELECTED:
      'Selezionare almeno uno o più metri a sinistra\npannello per la modifica dei valori di soglia.',
    THRESHOLDALARM: 'ALLARME DI SOGLIA',
    ALARMNAME: 'Nome allarme',
    MINTHRESHOLD: 'Soglia minima',
    MAXTHRESHOLD: 'Soglia massima',
    TO: 'a',
    RESETTODEFAULTS: 'Ripristino predefiniti',
    SAVE: 'SALVA',
    NOMETERSUNDERSITE: 'Nessun contatore disponibile',
    NOSITESAVAILABLE: 'Nessun sito disponibile',
    VALIDATIONREQUIRED:
      'Selezionare almeno una priorità e compilare tutti gli ingressi sottostanti',
    VALIDATIONOVERLAPPING:
      'Dati immessi non validi o sovrapposti ad altri valori'
  },
  urjanetStatus: {
    ENROLLED: 'Operazione conclusa correttamente',
    ENROLLEDMSG: "L'estrazione del conto è riuscita",
    SUCCESSFUL_DELIVERED: 'Consegna avvenuta con successo',
    SUCCESSFUL_DELIVEREDMSG:
      "L'estrazione e la consegna dei conti sono avvenute con successo",
    PRODUCTION: 'Produzione',
    PRODUCTIONMSG: "L'account è in produzione",
    Active: 'Attivo',
    ACTIVEMSG:
      "Esiste un account manuale e l'utente può inserire le fatture manuali.",
    Enroll_Successful: 'Enroll_Successful',
    FAILEDLOGIN: 'Accesso non riuscito',
    NEEDSCREDENTIAL: 'Richiede credenziali',
    NEEDSCREDENTIALMSG: "All'account non è associata una credenziale",
    FAILEDTOACCESS: 'Impossibile accedere.',
    NEEDSTEMPLATE: 'Richiede modello',
    NEEDSTEMPLATEMSG:
      "L'account dispone di una credenziale a cui non è assegnato un modello",
    UNDERREVIEW: 'In revisione',
    UNDERREVIEWMSG: 'Fallimento con stato generico',
    WEBSITEISSUE: 'Problema del sito Web',
    WEBSITEISSUEMSG: "L'account non riesce a connettersi al sito Web",
    CAPTCHALOGIN: 'Login Captcha',
    CAPTCHALOGINMSG: 'Accesso bloccato da Captcha sul sito Web',
    TEMPLATEFAILURE: 'Errore modello',
    TEMPLATEFAILUREMSG:
      "Un problema con il modello ha impedito un'estrazione di successo",
    NEEDSENROLLMENT: "Richiede l'iscrizione",
    NEEDSENROLLMENTMSG: "L'account deve essere iscritto",
    NOBILL: 'Nessuna fattura',
    NOBILLMSG: "L'account non dispone di una bolletta disponibile sul sito Web",
    REENROLLED: 'Reiscritto',
    REENROLLEDMSG:
      'Il conto è stato nuovamente iscritto dopo la disattivazione',
    NAVIGATIONFAILURE: 'Navigazione non riuscita',
    NAVIGATIONFAILUREMSG:
      'È necessaria una correzione del modello per questi conti',
    SOURCEFORMATCHANGE: 'Cambio Formato_sorgente',
    SOURCEFORMATCHANGEMSG: 'È stato rilevato un nuovo formato di fattura',
    ACCOUNTNUMBERCHANGE: 'Cambio di Account_Number',
    ACCOUNTNUMBERCHANGEMSG: 'Numero account modificato nel nuovo',
    USERACTIONREQUIRED: "Azione dell'utente richiesta",
    USERACTIONREQUIREDMSG: 'Azione richiesta dal cliente',
    MIGRATION: 'Migrazione',
    MIGRATIONMSG: 'Account migrato con il nuovo fornitore/numero account',
    INITIALTEMPLATEDEVELOPMENT: 'Sviluppo Modello_iniziale',
    INITIALTEMPLATEDEVELOPMENTMSG: 'Il modello è in fase di sviluppo',
    REJECTED: 'Rifiutato',
    REJECTEDMSG: "Conti rifiutati perché non validi per l'elaborazione",
    EBILLENROLLMENT: 'Iscrizione Ebill',
    EBILLENROLLMENTMSG:
      'Conto per il quale è richiesta/in sospeso la fatturazione elettronica',
    CREDENTIALUPDATED: 'Credenziale aggiornata',
    CREDENTIALUPDATEDMSG:
      "Le credenziali sono state aggiornate dopo un errore, il processo di verifica dell'account richiede 2/3 giorni.",
    TEMPLATEUPDATED: 'Modello aggiornato',
    TEMPLATEUPDATEDMSG: 'Il modello è stato aggiornato ma non è stato testato',
    UNKNOWN: 'Sconosciuto',
    UNKNOWNMSG: 'Lo stato del account è sconosciuto',
    PENDINGMSG: "Lo stato dell'account è in sospeso",
    PENDING: 'In sospeso',
    DELETED: 'Eliminato',
    DELETEDMSG: 'Il conto è stato eliminato',
    ENROLLMENTFAILUREMSG: "Errore durante l'iscrizione dell'account",
    ENROLLMENTFAILURE: 'Errore di iscrizione',
    DOESNOTEXIST: 'Inesistente',
    DOESNOTEXISTMSG: 'Il conto non esiste',
    ACCOUNTNUMBERMISMATCHMSG: 'Discrepanza numero di conto',
    ACCOUNTNUMBERMISMATCH: 'Discrepanza Account_Number',
    CONVERSIONINPROGRESS: 'Conversione in corso',
    CONVERSIONINPROGRESSMSG:
      'Conversione account in corso da manuale a automatico',
    FAILEDTOACCESSMSG:
      "L'estrazione non ha restituito nulla (potrebbe essere un nuovo sito Web o una navigazione interrotta)",
    FAILEDTOACCESSMSGIDS: 'Failed to access utility interval data',
    FAILEDLOGINMESSAGE:
      'Navigazione non riuscita nello specifico passaggio di accesso (controllare utente/password)',
    ACCOUNTMISSING: 'Conto mancante',
    ACCOUNTMISSINGMESSAGE:
      "La credenziale si è attivata e in qualche modo ha funzionato, ma non c'era traccia di questo account",
    CONNECTIONERROR: 'Errore di connettività',
    CONNECTIONERRORMESSAGE:
      'Si è verificato un errore, reinserire le credenziali "Fornitore del servizio" del conto.',
    CONNECTIONERRORMESSAGEIDS: 'Something went wrong.',
    BLOCKED: 'Conto bloccato',
    BLOCKEDMESSAGE: 'Accesso bloccato.',
    INACTIVE: 'Conto inattivo',
    INACTIVEMESSAGE: 'Il conto è inattivo.',
    FINALLED: 'Conto chiuso',
    FINALLEDMESSAGE:
      "Rivedere il conto e annullare l'iscrizione al conto se non è più in lavorazione.",
    VERIFICATIONINPROG: 'Verifica in corso',
    VERIFICATIONINPROGIDS: 'Activation in progress',
    REENROLLMENTPROG: 'Reiscrizione in corso',
    REACTIVATIONPROG: 'Reactivation in progress',
    SUBMITTED: 'Inviato',
    SUBMITTEDMSG:
      "Stato iniziale dell'account; dovrebbe procedere automaticamente",
    NOMINATEDPROG: 'Designato',
    METERSMISMATCHED: 'Discrepanza contatori',
    METERSMISMATCHEDMSG:
      "I dettagli del contatore non corrispondono. Aggiornare i dettagli del conto nella sezione 'Modifica dettagli conto'.",
    VERIFICATIONINPROGMESSAGE: 'La verifica conto richiede 2/3 giorni.',
    VERIFICATIONINPROGMESSAGEIDS: 'La verifica conto richiede 2/3 giorni.',
    REENROLLMENTTOOLTIP:
      "L'operazione di reiscrizione di questo conto viene riavviata dopo la disattivazione",
    REACTIVATIONTOOLTIP:
      'Reactivation action on this IDS account is initiated again after Deactivation',
    NOMINATEDMESSAGE:
      "L'account dispone di una credenziale fornita completa che non è ancora stata attivata",
    DATAUNAVAILABLE: 'Estratto conto non riuscito',
    STATEMENTMISSING: 'Dichiarazione mancante',
    DATAUNAVAILABLEMESSAGE:
      ' È stato ritirato un estratto conto ma non è stato conservato a causa di errori di verifica, di memorizzazione e così via.',
    STATEMENTMISSINGMSG:
      "La credenziale è stata eseguita e completata. L'account è stato visualizzato sul sito Web, ma non è stato possibile ottenere un estratto conto",
    NOTENROLLED: 'Non iscritto',
    NOTENROLLEDMESSAGE:
      'Estrazione conto riuscita, ma il conto in questione non è iscritto',
    DEACTIVATED: 'Disattivato',
    DEACTIVATEDMESSAGE: 'Il conto non è più attivo.',
    REVIEWACCOUNTANDUNS:
      "Rivedere il conto e annullare l'iscrizione al conto se non è più in lavorazione.",
    ERROR: 'Errore',
    ERRORMESSAGE: "Si è verificato un errore. Contattare l'amministratore.",
    LOGINFAILURE: 'Accesso mancato',
    LOGINFAILUREMESSAGE:
      'Accesso non riuscito per cambio password o conto fornitore di servizio scaduto.',
    DEACTIVATIONINITIATEDMSSG: 'Disattivazione avviata.',
    DEACTIVATIONINITIATED: 'Disattivazione in corso',
    REENROLLEDREQUIRED: 'Richiesta di reiscrizione',
    REENROLLEDREQUIREDMSG:
      "Per il conto è necessaria la reiscrizione. Immettere nuovamente le credenziali facendo clic sull'aggiornamento.",
    ENABLEIDSMSG: 'IDS (Interval Data Service) è stato abilitato con successo.',
    INTERVALSNOTSUPPORTED: 'Non supportato',
    INTERVALSNOTSUPPORTEDMSG:
      'IDS non è supportato dal fornitore di servizi per questo conto.',
    PLUGNEWACCOUNTMSG: 'Account iscritto con successo',
    PLUGEMAILAPPROVALMSG:
      "La verifica dell'account è in corso e Arcadia richiede l'approvazione dell'email da parte del cliente",
    PLUGCREDENTIALISSUEMSG:
      "Errore durante l'accesso ai dati di intervallo dell'utenza a causa di un problema con le credenziali",
    PLUGNODATAAVAILABLEMSG:
      "Impossibile accedere ai dati di intervallo dell'utenza poiché non sono disponibili dati",
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      "Impossibile accedere ai dati di intervallo dell'utenza poiché l'approvazione dell'email non è riuscita",
    PLUGINVALIDCREDENTIALSMSG:
      'Errore di connessione a causa di credenziali non valide'
  },
  virtualMeters: {
    SELECTED: "Contatori dell'elettricità - ({count}) selezionati",
    SEARCHMETERS: 'Cerca nome contatore',
    METERGROUPDETAILS: 'DETTAGLI GRUPPO CONTATORI',
    METERGROUPNAME: 'Nome gruppo contatori',
    DESCRIPTION: 'Descrizione',
    DESCRIPTIONPLACEHOLDER: 'Massimo 240 caratteri',
    VALIDATIONREQUIRED:
      'È necessario selezionare almeno due metri ed entrambi gli ingressi devono essere riempiti',
    SAVE: 'SALVA',
    CANCEL: 'ANNULLA'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Emissioni totali',
    TOTALEMISSION: 'Totale emissioni',
    SCOPEONETITLE: 'Emissioni di carbonio per ambito 1',
    SCOPETWOTITLE: 'Emissioni di carbonio per ambito 2',
    SCOPE1: 'Ambito 1',
    SCOPE2: 'Ambito 2',
    SCOPEONEDATANOTCONSIDER:
      "I dati dell'ambito 1 necessitano di aggiornamenti",
    CARBONTITLE: 'Profilo emissioni di carbonio',
    PORTFOLIOCARBONTITLE: 'Emissioni di carbonio in portafoglio (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      "Emissioni calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente.",
    CARBONTOOLTIPSUTILITYDETAIL:
      "Emissioni calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sulla bolletta dell'utenza fornita.",
    CARBONTOOLTIPLIVEDETAIL:
      "Emissioni calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente dal contatore in loco. I calcoli delle emissioni di carbonio in tempo reale si basano sul contatore principale.",
    CARBONTOOLTIPINTRVALDETAIL:
      "Emissioni calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sui dati di intervallo dell'utenza.",
    SCOPEONETOOLTIP:
      "Emissioni dirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente.",
    SCOPETWOTOOLTIP:
      "Emissioni indirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente.",
    SCOPEONETOOLTIPUTILITY:
      "Emissioni dirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sulla bolletta dell'utenza fornita.",
    SCOPEONETOOLTIPINTERVAL:
      "Emissioni dirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sui dati di intervallo dell'utenza.",
    SCOPEONETOOLTIPLIVE:
      "Emissioni dirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente dal contatore in loco. I calcoli delle emissioni di carbonio in tempo reale si basano sul contatore principale.",
    SCOPETWOTOOLTIPdUTILITY:
      "Emissioni indirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sulla bolletta dell'utenza fornita.",
    SCOPETWOTOOLTIPINTERVAL:
      "Emissioni indirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente. I calcoli delle emissioni di carbonio effettivi si basano sui dati di intervallo dell'utenza.",
    SCOPETWOTOOLTIPLIVE:
      "Emissioni indirette calcolate per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente dal contatore in loco. I calcoli delle emissioni di carbonio in tempo reale si basano sul contatore principale.",
    CARBONDETAILKEY: 'Dettaglio carbonio',
    SCOPEONEKEY: 'riepilogo dettaglio senza valuta',
    UTILITYDETAILKEY: 'dettaglio servizio',
    METER: 'CONTATORE',
    METERNAME: 'NOME CONTATORE',
    FUELTYPE: 'TIPO DI CARBURANTE',
    SITES: 'SITI',
    SOURCE: 'ORIGINE',
    CURRENTAVOIDANCE: 'ELIMINAZIONE ATTUALE',
    PREVIOUSAVOIDANCE: 'ELIMINAZIONE PRECEDENTE',
    UTILITYTYPE: 'TIPO DI SERVIZIO',
    ACTUALEMISSION: 'EMISSIONI EFFETTIVE',
    ACTUALEMIS: 'EMIS. EFFETT.',
    PREVIOUSEMISSION: 'EMISSIONI PRECEDENTI',
    PREVIOUSPERIOD: 'EMISS. PRECEDENTI',
    PREVIOUSEMISSIONS: 'Emissioni precedenti',
    PORTFOLIOPREVIOUSConsumption: 'PERIODO PRECEDENTE',
    PORTFOLIOACTUALEMISSION: 'EMISSIONI EFFETTIVE',
    PORTFOLIOPREVIOUSEMISSION: 'EMISSIONI PREC.',
    PORTFOLIOPREVIOUSCOST: 'COSTO PREC.',
    CHANGE: 'MODIFICA',
    ACTUALCONS: 'CONS. EFFETT.',
    BASELINECONSP: 'CONS. DI RIFER.',
    PREVPERIOD: 'PERIODO PREC.',
    CHANGEPERCENT: '%MODIFICA',
    EUICURRENT: 'EUI CORRENTE',
    EUIPRVPERIOD: 'EUI PREC. PERIODO',
    PORTFOLIOACTUALCOST: 'COSTO EFFETTIVO',
    SAVINGS: 'RISPARMI',
    FuelType: 'Tipo di combustibile',
    Emissions: 'EMISSIONI',
    CARBONAVOIDANCE: 'Eliminazione del carbonio',
    carbonEmissionsAvoidance: 'Eliminazione delle emissioni di carbonio',
    TOTALAVOIDANCETOOLTIP:
      "Eliminazione del carbonio calcolato per la durata selezionata dai valori effettivi rispetto ai dati dell'anno precedente.",
    Meters: 'Contatori',
    ActivePower: 'Alimentazione attiva',
    ActivePowerContent:
      'Potenza istantanea misurata per un determinato istante di tempo.',
    AVGpower: 'Potenza media',
    PeakPower: 'Alimentazione di picco',
    PeakPowerContent:
      "Richiesta di potenza massima per la selezione dell'intervallo di date.",
    LoadType: 'Tipo di carico',
    LoadTypeContent: 'Tipo di carico a cui è associato il contatore.',
    FifteenMinuteElectricConsumption: 'Consumo 15 min.',
    FifteenMinuteElectricConsumptionPrediction: 'Prev. 15 min.',
    ElectricityConsumption: 'Consumo totale di energia',
    EnergyConsSelectedPeriod: 'Consumo di energia nel periodo selezionato',
    EnergyConsToday: 'Consumo energetico oggi',
    EnergyConsTodayContent: 'Consumo energetico totale per oggi.',
    EnergyConsMonth: 'Consumo mensile di energia',
    EnergyConsMonthContent: 'Consumo energetico totale per il mese corrente.',
    TotalEnergyConsumption: 'Consumo energetico complessivo',
    TotalEnergyConsumptionContent: 'Consumo totalizzato dei contatori',
    EnergyConsSelectedPeriodContent:
      'Consumo di energia nel periodo selezionato',
    DataQuality: 'Qualità dei dati',
    BaselineQuality: 'Qualità di riferimento',
    PowerDemand: 'Richiesta alimentazione',
    APPLYBASELINEFROMDATEINVALID:
      'Selezionare una data non precedente agli ultimi 15 giorni',
    INVALIDEXCLUSIONRANGESELECTION:
      "Selezionare la data di esclusione entro l'intervallo di date selezionato per l'addestramento"
  },
  NILM: {
    NILMModalHeader: 'Registrati per NILM',
    NILMMeterDetails: 'Aggiungi dettagli NILM',
    SmartXMeter: 'Anteprima',
    NILMDetailsTabHeader:
      'Inserire i dettagli del contatore del monitoraggio non intrusivo del carico (NILM) per aggiungerli in HSBM',
    NILMDetailsTabSubHeader: 'Dettagli contatore NILM',
    NILMMeterId: 'ID dati/UUID',
    NILMDISAGGREGATEDMETERID: 'ID dati disaggregati/UUID (facoltativo)',
    NILMMeterName: 'Nome contatore',
    NILMAddMeter: 'Aggiungi contatore',
    NIMAssignMainMeter: 'Assegna come contatore principale',
    NILMNextButton: 'Avanti',
    NILMSubmitButtom: 'Invia',
    NILMCancelButton: 'Annulla',
    NILMcardheader: 'Monitoraggio del carico non intrusivo (NILM)',
    NILMcardsubheader:
      'Determinare la composizione del consumo energetico del sito in base ai tipi di apparecchiatura',
    NILMRedirect: 'Si verrà reindirizzati tra 5 secondi.',
    NILMAccountVerification: 'Verifica account in corso',
    NILMAccountVerificationSuccess:
      "La verifica dell'account è stata completata con successo",
    INVALIDNILMMETERID: 'ID installazione contatore non valido',
    METERNAMEINVALID: 'Nome del contatore già esistente per il sito',
    NILMMainmeter: '(assegnato come contatore principale)',
    NILMsmartXmeterheader:
      'Di seguito sono riportati i contatori NILM. Verificare per continuare e fare clic su Invia',
    NILMDUPLICATEMETERNAME: 'Nome contatore duplicato',
    NILMDUPLICATEMETERID: 'ID contatore duplicato',
    IDDUPLICATETOGETHER: 'UUID non valido e duplicato',
    NAMEDUPLICATETOGETHER: 'Nome del contatore già esistente e duplicato'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'Per il periodo di 12 mesi che termina -',
    NoRecordsFound: 'Nessun record trovato',
    LearnText: 'Per saperne di più',
    outOfHundred: '/100',
    CurrentScore: 'Punteggio corrente',
    EnergyTooltipHeader: 'Consumo energetico',
    EnergyTooltipContent:
      "Il punteggio Energy Star definisce il livello prestazionale dell'immobile rispetto ad altri simili quando normalizzato per caratteristiche climatiche e operative.",
    EnergyStarTitle: 'Punteggio Energy Star',
    loading: 'Caricamento in corso',
    ViewText: 'Visualizza dettagli punteggio',
    NA: 'N/D',
    SomethingWentWrong: 'Nota',
    notifyServerError:
      "Si è verificato un errore lato server. Contattare l'amministratore del sistema.",
    ReasonForNoScoreLabel:
      'Impossibile caricare il punteggio Energy Star a causa di alcuni errori tecnici.',
    ViewReasonForNoScore:
      "Visualizza dettagli del motivo dell'assenza di punteggio",
    EnergyStarNoScoreNote:
      'The Energy Star score displayed is from {prevMonth}, as the previous month score is unavailable.',
    EnergyStarNoScoreNoContentMessage:
      "Nessun motivo trovato per l'assenza di informazioni sul punteggio!",
    EnergyStarNoScoreForLastMonthLabel:
      'Impossibile caricare il punteggio Energy Star per il mese precedente. Da qui il risultato visualizzato del mese recente.'
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '"{fileName}" è un formato file non valido. Si accetta solo il formato file .{extension}',
    INVALIDFILE_EXTENSION:
      'Estensione file non valida. Utilizzare un file .{extension} valido',
    INVALIDFILE_MIME:
      'Tipo di file MIME non valido; usare un file con tipi MIME validi: {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE:
      'La dimensione del file deve essere inferiore a {size}',
    INVALIDFILE_MINALLOWEDSIZE:
      'La dimensione del file deve essere superiore a {size}',
    INVALIDFILE_UNKNOWNERROR:
      "Si è verificato un errore durante l'accesso alle informazioni sui file. Impossibile convalidare",
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'Il file Excel caricato contiene colonne non valide. Utilizzare il modello appropriato e caricare di nuovo il file Excel.',
    INVALID_SCHEMA_LIST_REQ_HEADERS:
      'Intestazioni richieste: {requiredSubHeaders}',
    EMPTY: '',
    NO_DATA: 'Il file non contiene dati',
    INVALID_DATA_CONTENT:
      'La prima riga di dati deve contenere un elemento spaziale',
    SOME_ERROR_EXCEL_READ:
      'Si è verificato un errore durante la lettura del file Excel. Errore: {errorString}',
    SOME_ERROR_GENERAL:
      'Si è verificato un errore. Selezionare di nuovo un file valido e caricarlo. Dettagli errore -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Tipo dati non valido. Concesso: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'Il nome ha un carattere speciale non valido',
    NAME_INVALID_MAX_LEN: 'Massimo {len} caratteri consentiti',
    SPATIAL_ELE_NEW: 'Verrà creata una nuova area',
    NO_ASSOC_REMOVE:
      'Nessun VAV/Sensore di occupazione mappato. Rimuovere questa voce',
    PROPERTIES_INVALID: 'Alcune proprietà non sono valide',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      "L'ID dell'elemento spaziale fornito ({id}), il nome dal foglio e il nome registrato nel sito web ({dbSpEleName}) non corrispondono",
    ELEMENT_NAME_MISMATCH:
      "L'ID dell'elemento fornito ({id}), il nome del foglio e del nome registrato nel sito web ({dbEleName}) non corrispondono",
    DUPLICATE_ENTRIES: 'Più voci con lo stesso nome',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'Il sito dispone di più apparecchiature registrate con lo stesso nome. Rinominare questa apparecchiatura con un nome univoco da associare',
    ELEMENT_ID_DNE: "{type} con l'ID fornito ({id}) non esiste",
    SPATIAL_ELEMENT_ID_DNE: "L'area con ID fornito ({id}) non esiste",
    ELEMENT_TYPE_NAME_DNE: '{type} con questo nome non esiste',
    PROPERTY_DNE: 'La proprietà con nome {name} non esiste. Verificare'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO:
      'Mappatura e configurazione dello spazio attrezzatura ZLO',
    UPLOAD_CARD_DESC_ZLO:
      "Caricare i dati dell'apparecchiatura per la mappatura dello spazio per l'onboarding e la configurazione ZLO",
    UPLOAD_MODAL_TITLE: 'Carica dati di onboarding ZLO',
    VALIDATE_DATA: 'Carica',
    BACK_TO_UPLOAD: 'Indietro',
    UPLOAD_TAB_TOP_NOTE:
      "Scaricare il modello e, prima di procedere al caricamento, compilare i dettagli dell'elemento spaziale insieme ai dettagli relativi all'apparecchiatura nel modello",
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Scarica modello XLSX',
    UPLOAD_TAB_SECOND_NOTE:
      'È possibile effettuare solo un caricamento alla volta.',
    UPLOAD_TAB_PLACEHOLDER: 'Trascina il file del logo qui',
    VALIDATING_FILE_DATA: 'Convalida dei dati del file',
    READING_FILE: 'Lettura file',
    VALIDATING_FILE_SCHEMA: 'Convalida dello schema di file',
    RETRIEVING_SITE_DATA: 'Recupero dati sito per convalida',
    VALIDATING_DATA_ENTRIES: 'Convalida dati',
    ALL_ENTRIES_VALID: 'Tutte le voci sono valide',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Fare clic su Invia per continuare e registrarsi in HBSM',
    VIEW_ALL_ENTRIES: 'Visualizza tutte le voci',
    FIX_VAL_ERRORS_MSG:
      'Di seguito sono riportate le voci errate dei dati di configurazione e di onboarding ZLO. Tornare alla scheda di caricamento e caricare di nuovo Excel senza le voci errate per registrarsi in HBSM',
    VAL_OK_SUBMIT_MSG:
      'Fare clic su Invia per continuare e registrarsi in HBSM',
    ERROR_BOX_TEXT:
      '{numErrors} errori identificati. Correggerli e ricaricare il file, inviarlo e registrarlo in HBSM.',
    VALIDATION_ERROR_TITLE: 'Errore durante la convalida',
    TOTAL: 'Totale',
    CURRENTLY_SHOWING: 'Visualizzati {num} di {total} totali',
    SHOW_ALL_ENTRIES: 'Mostra tutte le voci',
    SL_NO: 'N. serie',
    SPATIAL_ELE_NAME: "Nome dell'elemento spaziale",
    ELE_TYPE: 'Tipo elemento',
    ELE_NAME: 'Nome',
    ZLO_STATE: 'Stato ZLO',
    ZO_SETBACK: 'Riduzione ottimizzazione zona (F)',
    VAV: 'Volume aria variabile',
    OCCUPANCY_SENSOR: 'Sensore di occupazione',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'Sensore di occupazione',
    SEARCH_PLACEHOLDER: 'Cerca',
    SEARCH_MIN_LEN: 'Min. {len} caratteri',
    NO_DATA: 'Nessun dato corrisponde alla ricerca',
    VALIDATING_TITLE: 'Convalida del file caricato in corso',
    SOME_ERROR_FETCHING_DATA:
      'Si è verificato un errore durante il recupero dei dati del sito. Errore: {errorString}',
    SUBMITTING_TITLE: "Attendere mentre mappiamo l'apparecchiatura allo spazio",
    SUBMITTING_SUBTITLE: 'Tra pochi secondi verrete reindirizzati',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Creazione di nuovi spazi in corso',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS:
      'Mappatura delle apparecchiature agli spazi in corso',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      "Errore durante la mappatura dell'elemento a un elemento spaziale. Riprovare in seguito",
    UPDATING_PROPERTIES: 'Aggiornamento proprietà in corso',
    SUBMISSION_SUCCESS_TITLE:
      "La mappatura dell'apparecchiatura allo spazio è riuscita",
    SUBMISSION_ERROR_TITLE: "Errore durante l'invio di dati",
    SUBMISSION_ERROR_MESSAGE:
      "Errore durante l'invio di dati. Riprovare in seguito",
    BULK_CREATION_ERROR_MESSAGE:
      'Si è verificato un errore durante la creazione di elementi spaziali. Riprovare in seguito.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      "Si è verificato un errore durante l'aggiornamento delle proprietà. Riprovare in seguito.",
    SUBMISSION_SUCCESS_SUBTITLE:
      'I sensori VAV e di occupazione mappati sugli spazi si riflettono nella scheda delle apparecchiature nella home page del sito',
    GOTO_SITE_HOME_PAGE: 'Andare alla home page del sito',
    'Items per Page': 'Righe per pagina'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'Le informazioni sottostanti vengono sempre mostrate in base al ciclo di informazioni di fatturazione'
  },
  UtilityBuilder: {
    NEWBILL: 'Nuova bolletta',
    ENTERDATAMANUALLY: 'Immettere i dati manualmente',
    BILLNAME: 'Nome bolletta',
    BILLINGDATE: 'Data di fatturazione',
    TOTAL_BILL_AMOUNT: 'Importo totale della bolletta',
    BILLING_PERIOD_CONSUMPTION: 'Consumo del periodo di fatturazione',
    BILLING_DEMAND: 'Richiesta di fatturazione',
    ENTER_PLACEHOLDER: 'Immettere',
    SELECT_PLACEHOLDER: 'Selezionare',
    CATEGORIES: 'Categorie',
    ACCOUNTNUMBER: 'Numero account',
    UTILITYTYPE: 'Tipo di servizio',
    BILLINGCYCLE: 'Ciclo di fatturazione',
    UPLOADELECTRICITYBILL: 'Caricare bolletta energia elettrica',
    UPLOADGASBILL: 'Caricare bolletta del gas',
    ADDELECTRICITYBILL: 'Aggiungi bolletta energia elettrica',
    ADDGASBILL: 'Aggiungi fattura {utilityType}',
    UPLOADUTILITYBILL: 'Caricare bolletta di fornitura',
    PDFUPLOADPROMPT: 'Caricare un file PDF della bolletta di fornitura',
    UploadElectricitybill: "Caricare fattura per l'elettricità*",
    Utilitybill: 'Bolletta',
    UPLOADBILL: 'Caricare {utilityType} bolletta',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Caricare bolletta energia elettrica',
    FILENAMECONTAINSPACES: 'Il nome file contiene spazi.',
    FILENAMECONTAINSPECIALCHARACTER:
      'Il nome file contiene caratteri speciali.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Categorie di bollette',
    REFERSAMPLEBILL: 'Vedere esempio di bolletta.',
    INPUTCATEGORIES:
      'Inserire le diverse categorie e i costi corrispondenti dalla propria bolletta {utilityType}. Se è necessaria assistenza per individuarli nella fattura, '
  },
  baseline: {
    baselineconfiguration: 'Configurazione di base',
    baselineConfigDesc:
      "Le linee di riferimento regolate stabiliscono il consumo previsto dell'utenza per un sito, sulla base di una combinazione di consumo storico, tendenze recenti e effetti conosciuti, come le variabili meteo.",
    baseline: 'Riferimento',
    total: 'Totale',
    searchPlaceholder: 'Cerca',
    create: 'Crea linea di riferimento',
    view: 'Visualizza linea di base',
    baselineQuality: 'Qualità di riferimento',
    baselinePeriod: 'Periodo di riferimento',
    reportingPeriod: 'Periodo della segnalazione',
    estBaselinePeriod: 'Stabilire il periodo di riferimento',
    baselinePeriodDescription:
      'Selezionare il periodo di riferimento e il periodo di reporting per il quale creare la linea di riferimento',
    independentVariables: 'Variabili indipendenti',
    autoSelectBest: 'Selezione automatica delle variabili migliori',
    utilityDataType: 'Tipo di dati utenza',
    calendarMonth: 'Mese di calendario',
    billingPeriod: 'Periodo di fatturazione',
    tStat: 'T-Stat'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'AGGIUNGI ACCOUNT',
    ADD_METERS: 'AGGIUNGI CONTATORE'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Importo totale della bolletta',
  Consumption: 'Consumo',
  Demand: 'Richiesta',
  'Service Charges': 'Spese di servizio',
  'Transmission & Distribution': 'Trasmissione e distribuzione',
  Others: 'Altri',
  'Demand Charges': 'Spese per la richiesta',
  'Total Cost': 'Costo totale',
  Total: 'Totale'
};
